import ReactDOM from "react-dom";
import React from "react";
//
import App from "./App";
import { store, persistor } from "./store/store";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import { validateAndPurgeIfExpired } from "./utils/sessionExpiry";
// ----------------------------------------------------------------------

// Codex CRITICAL fix: validate JWT exp BEFORE the React tree renders so
// expired sessions don't briefly render protected UI from persisted state.
// If invalid/expired, this purges localStorage so PersistGate rehydrates a
// clean (logged-out) state and PermissionGuard redirects to /login.
// Backend MUST still validate exp on every protected request — this is a
// client-side belt; the server cookie/JWT check is the braces.
validateAndPurgeIfExpired();

// const root = ReactDOM.createRoot(document.getElementById('root'));

ReactDOM.render(
  <>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <App />
      </PersistGate>
    </Provider>
  </>,
  document.getElementById("root")
);
